import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import { TiPlus, TiDelete } from "react-icons/ti";
import Swal from "sweetalert2";

const ManageInputField = () => {
  const [field, setField] = useState([]);
  const [showModal, setShow] = useState(false);
  const [fieldInput, setFieldInput] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeField = (event) => {
    let value = event.target.value;

    setFieldInput(value.split(" ").join("_").toLowerCase());
  };

  const submitField = (event) => {
    event.preventDefault();
    axios
      .post(`https://productspec.cyclic.app/form_field/`, {
        field: fieldInput,
      })
      .then((res) => {
        setField([...field, res.data.uploadField]);
        setShow(false);
        setFieldInput("");
      });
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const deleteField = (event) => {
    const _id = event.target.value;
    Swal.fire({
      title: `Hapus field?`,
      text: `Yakin ingin hapus?`,
      icon: "warning",
      confirmButtonText: "Ya",
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "Tidak",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`https://productspec.cyclic.app/form_field/${_id}`)
          .then((res) => {
            setField(res.data);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire("Batal", "Batal hapus field", "error");
      }
    });
  };

  useEffect(() => {
    axios.get(`https://productspec.cyclic.app/form_field/`).then((response) => {
      setField(response.data);
    });
  }, []);

  return (
    <div className="page-add">
      <h2 className="text-center fw-bold">Daftar Field Input</h2>
      <div className="btn-modal-add  mb-3 mt-3">
        <button className="btn-open-modal" onClick={handleShow}>
          <span className="icon-open-modal">
            <TiPlus />
          </span>
          Tambah Field Inputan
        </button>
      </div>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Tambah Field Inputan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <form onSubmit={submitField}>
              <div className="">
                <label htmlFor="field" className="form-label">
                  Input Field
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="field"
                  onChange={handleChangeField}
                  value={fieldInput}
                  name="field"
                  placeholder="field..."
                />
              </div>
              <div className="bg-light mt-3 text-center">
                <button type="submit" className="btn btn-primary pull-right">
                  Tambah
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="nostyle-btn btn-close-modal" onClick={handleClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <table className="table table-hover table-secondary mt-2 ">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Field</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {field.length !== 0 ? (
            field.map((el, i) => (
              <tr key={el._id}>
                <td style={{ width: "15%" }}>{i + 1}</td>
                <td style={{ width: "65%" }}>{el.field}</td>
                <td style={{ width: "20%" }}>
                  <button
                    className="btn btn-danger"
                    onClick={deleteField}
                    value={el._id}
                  >
                    delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="text-center">
                Tidak ada data
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ManageInputField;
